import { GeschaeftspartnerListPage } from "@/pages/kontakte/GeschaeftspartnerListPage";

export function KundenIndexPage() {
  return (
    <GeschaeftspartnerListPage
      typ="kunde"
      title="Kunden"
      detailBasePath="/kontakte/kunden"
    />
  );
}
